export const validateArticleForm = (data) =>{

    const requiredFields = [
        "articleTitle",
        "articleAuthor",
        "articleSection",
    ]

    var validFieldCount = 0
    
    requiredFields.forEach((field)=>{
        if(data[field] && data.articleTagsArray.length ){
            validFieldCount = validFieldCount + 1
            // console.log(field , true)
        }else{
            // console.log(field , false)
        }
    })

    if(validFieldCount===requiredFields.length){
        return true
    }else{
        return false
    }
}

